import { store } from '@/store/store'
import axios from 'axios'
import config from '@/config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lineApi = {
  getLineInfo: (request) => {
    const { params } = request
    return instance().get(`api/lineInfo/${params.pageid}`, {
      params: params
    })
  }
}
export default lineApi



// WEBPACK FOOTER //
// ./src/api/line.js